module.exports = __webpack_public_path__ + "static/media/arvind-profile.498abe96.png";